module.exports = __webpack_public_path__ + "media/images/exchange-29b98f97a914dd3168de7a88c52a12d1.svg";